import React, { Component } from 'react';
import { connect } from 'react-redux';
import Home from './home';
import Timeline from './timeline';
import { Container, Icon, Button, Popup, Menu } from 'semantic-ui-react';
import moment from 'moment';
import Picker from '../../components/DateRangePicker';
import Page from '../../components/Page';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import AnalyticsIcon from '@mui/icons-material/Analytics';

class Analytic extends Component {
	state = {
		loading: true,
		filter: '',
		type: 'day',
		start_date: moment().subtract(7, 'day').startOf('day'),
		end_date: moment(),
		today: moment(),
		open: false,
		column: null,
		direction: null,
	};
	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};
	header() {
		// let diffDate = moment(trialEndDate).diff(moment().startOf('day'), 'days');
		const { start_date, end_date } = this.state;
		return (
			<>
				<div style={{ marginLeft: 'auto' }}>
					<Popup
						popperModifiers={{
							preventOverflow: { enabled: false },
						}}
						trigger={
							<Button
								primary
								content={`${moment(start_date).locale('en').format('MMM DD, YYYY')} - ${moment(end_date).locale('en').format('MMM DD, YYYY')}`}
								floated="right"
							/>
						}
						content={<Picker dateChange={this.dateChange} startDate={start_date.toDate()} endDate={end_date.toDate()} />}
						on="click"
						position="top right"
						flowing
						onClose={this.refresh}
					/>
				</div>
			</>
		);
	}

	render() {
		let { product } = this.props;
		let subscription = product && product.settings && product.settings.subscription_package;
		let timeline_analytic = true; //product && product.settings && product.settings.timeline_analytic;
		return (
			<Page title="Analytic" icon={<AnalyticsIcon />} head={this.header()}>
				<Page.Wrap>
					<Container>
						<Menu>
							{subscription !== 'api' ? (
								<Menu.Item as={NavLink} exact to="/analytic/">
									<Icon name="table" />
									Analytic
								</Menu.Item>
							) : (
								''
							)}
							{timeline_analytic ? (
								<Menu.Item as={NavLink} exact to="/analytic/timeline">
									<Icon name="bars" />
									Timeline
								</Menu.Item>
							) : (
								''
							)}
						</Menu>
					</Container>
				</Page.Wrap>
				<Switch>
					{timeline_analytic ? (
						<Route path="/analytic/timeline" render={() => <Timeline start_date={this.state.start_date} end_date={this.state.end_date} />} />
					) : (
						''
					)}
					{subscription !== 'api' ? (
						<Route path="/analytic/" exact render={() => <Home start_date={this.state.start_date} end_date={this.state.end_date} />} />
					) : (
						''
					)}
					{subscription === 'api' && timeline_analytic ? <Route path="/analytic" render={() => <Redirect to="/analytic/timeline" />} /> : ''}
				</Switch>
			</Page>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product.maytapi });
export default connect(stateToProps)(Analytic);
